import { Component, Host, h, Prop } from '@stencil/core'

/**
 * Component which shows how many loyalty points can be earned for a given
 * amount of money. It also shows a CTA to sign up for the loyalty program.
 *
 * @example
 *
 * <wf-loyalty-cta />
 */
@Component({
    tag: 'wf-loyalty-cta',
    styleUrl: 'wf-loyalty-cta.scss',
    shadow: true,
})
// eslint-disable-next-line require-jsdoc
export class WfLoyaltyCta {
    /**
     * The text for the CTA.
     */
    @Prop() text: string

    /**
     * The link for the CTA.
     */
    @Prop() link?: string

    /*
    * Determines if the CTA should be filled or not.
    */
    @Prop() filled?: boolean = false

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (
            <Host>
                <a href={this.link} class={{
                    cta: true,
                    filled: this.filled,
                }}>
                    {this.text}
                </a>
            </Host>
        );
    }
}
